export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS'
export const SET_PAGE_PARAMS = 'SET_PAGE_PARAMS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'

export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'

export const START_DOWNLOADING = 'START_DOWNLOADING'
export const STOP_DOWNLOADING = 'STOP_DOWNLOADING'

export const GET_ALL_COLUMNS_SUCCESS = 'GET_ALL_COLUMNS_SUCCESS'
export const GET_ALL_COLUMNS_FAILURE = 'GET_ALL_COLUMNS_FAILURE'

export const SAVE_USER_PREFS_COLUMNS_SUCCESS = 'SAVE_USER_PREFS_COLUMNS_SUCCESS'
export const SAVE_USER_PREFS_COLUMNS_FAILURE = 'SAVE_USER_PREFS_COLUMNS_FAILURE'

export const GET_USER_PREFS_COLUMNS_SUCCESS = 'GET_USER_PREFS_COLUMNS_SUCCESS'
export const GET_USER_PREFS_COLUMNS_FAILURE = 'GET_USER_PREFS_COLUMNS_FAILURE'

export const UPDATE_CONTACT_REQUESTED = 'UPDATE_CONTACT_REQUESTED'
export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS'
export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE'

export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS'
export const GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE'

export const SET_LAST_SEARCH_ID = 'SET_LAST_SEARCH_ID'

export const GET_CONTACTS_STATS_SUCCESS = 'GET_CONTACTS_STATS_SUCCESS'

export const GET_CONTACT_STATS_FAILURE = 'GET_CONTACT_STATS_FAILURE'

export const GET_CONTACTS_CANCEL = 'GET_CONTACTS_CANCEL'

export const GET_MOST_RECENT_SEARCH_SUCCESS = 'GET_MOST_RECENT_SEARCH_SUCCESS'
export const GET_MOST_RECENT_SEARCH_FAILURE = 'GET_MOST_RECENT_SEARCH_FAILURE'

export const POST_MOST_RECENT_SEARCH_SUCCESS = 'POST_MOST_RECENT_SEARCH_SUCCESS'
export const POST_MOST_RECENT_SEARCH_FAILURE = 'POST_MOST_RECENT_SEARCH_FAILURE'

export const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE'
export const GET_PAGE_SIZE_FAILURE = 'GET_PAGE_SIZE_FAILURE'

export const GET_EVAL_FORMS_SUCCESS = 'GET_EVAL_FORMS_SUCCESS'
export const GET_EVAL_FORMS_FAILURE = 'GET_EVAL_FORMS_FAILURE'

export const GET_METADATA_OPERATORS_SUCCESS = 'GET_METADATA_OPERATORS_SUCCESS'
export const GET_METADATA_OPERATORS_FAILURE = 'GET_METADATA_OPERATORS_FAILURE'

export const GET_RECORDING_TYPES_SUCCESS = 'GET_RECORDING_TYPES_SUCCESS'
export const GET_RECORDING_TYPES_FAILURE = 'GET_RECORDING_TYPES_FAILURE'

export const GET_TIME_ZONES_SUCCESS = 'GET_TIME_ZONES_SUCCESS'
export const GET_TIME_ZONES_FAILURE = 'GET_TIME_ZONES_FAILURE'

export const GET_METADATA_FIELDS_SUCCESS = 'GET_METADATA_FIELDS_SUCCESS'
export const GET_METADATA_FIELDS_FAILURE = 'GET_METADATA_FIELDS_FAILURE'

export const SAVE_RECORDINGS_COLUMN_WIDTHS = 'SAVE_RECORDINGS_COLUMN_WIDTHS'
export const GET_RECORDINGS_COLUMN_WIDTHS = 'GET_RECORDINGS_COLUMN_WIDTHS'

export const UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_SAVE = 'UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_SAVE'
export const UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_RESET = 'UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_RESET'

// Used for local storage
export const RECORDINGS_COLUMN_WIDTHS = 'RECORDINGS_COLUMN_WIDTHS'

export const COLUMN_CATEGORY = {
  ORGANIZATION: 'organization_fields',
  EVALUATION: 'evaluation_fields',
  DATE: 'date_fields',
  CONTACT: 'contact_fields',
  ANALYSIS: 'analysis_fields',
  CAA: 'caa_fields',
  METADATA: 'metadata_fields',
} as const

export const UPLOAD_STATE = {
  UPLOADED: 2,
  DELETED: 5,
  RECYCLED: 6,
} as const

export const RECORDING_REASON = {
  NO_RECORDING: -13,
  NO_SIP_EVENT: -12,
  COMPLIANCE_LICENSE: -11,
  ARCHIVE_OFF: -10,
  NO_RULES: -9,
  NOT_WHO: -8,
  NOT_WHEN: -7,
  NOT_WF_CLASSIFIER: -6,
  UNDER_MIN: -5,
  IN_EXCLUSION: -4,
  NOT_INCLUSION: -3,
  DELETED_CLIENT: -2,
  NO_WF_TEAM: -1,
  NOT_PROCESSED: 0,
  FIRST: 1,
  LAST: 2,
  LONGEST: 3,
  SHORTEST: 4,
  RANDOM: 5,
  NEW_EMP: 6,
  PERFORMANCE: 7,
  LOGGING: 8,
  TAGGED: 9,
  ARCHIVE: 10,
  ANALYTICS_TAGGED: 11,
  MARKED_FOR_QUALITY: 12,
  NON_CALL: 13,
  ARCHIVE_TAGGED: 14,
  SURVEY_TRIGGERED: 15,
  UNTAGGED: 16,
  ARCHIVE_UNTAGGED: 17,
  API_IMPORTED: 18,
} as const

export const COLUMN_I18N_MAPPING: { [key: string]: string } = {
  organization_fields: 'organization',
  first_name: 'firstName',
  last_name: 'lastName',
  group_name: 'groupName',
  team_name: 'teamName',
  agent_acd_id: 'agentAcdId',
  site_name: 'site',
  license: 'licenseType',

  evaluation_fields: 'evaluation',
  evaluation_score: 'percentageScore',
  evaluator_name: 'evaluatorName',
  evaluation_date: 'dateEvaluated',
  approved_by: 'approvedBy',
  evaluation_form_name: 'evaluationForm',
  evaluation_calibration: 'calibrated',
  eval_response_date: 'evalResponseDate',
  eval_response_state: 'evalResponseState',

  date_fields: 'date',
  date: 'date',
  time: 'time',
  tz: 'tz',

  contact_fields: 'contact',
  call_state: 'state',
  call_active: 'callActive',
  call_line: 'callLine',
  line: 'callLine',
  called_number: 'calledNumber',
  calling_number: 'callingNumber',
  direction: 'direction',
  call_duration: 'callDuration',
  id: 'contactId',
  ani: 'callingNumber',
  dnis: 'calledNumber',
  quality_reason: 'reason',
  recording_type: 'recordingType',
  hr: 'hr',
  training: 'training',
  evaluation_state: 'state',
  contact_type: 'contactType',
  to_address: 'toAddress',
  from_address: 'fromAddress',
  subject: 'subject',
  surveyScore: 'surveyScore',
  surveyName: 'surveyName',
  audioFileUploadStateId: 'audioFileUploadStateId',
  videoFileUploadStateId: 'videoFileUploadStateId',
  retention_policy: 'retentionPolicyName',

  analysis_fields: 'speechFields',
  silence_max_duration: 'maxSilenceDuration',
  silence_min_duration: 'minSilenceDuration',
  silence_average_duration: 'averageSilenceDuration',
  silence_total_duration: 'totalSilenceDuration',
  silence_total_events: 'silenceEvents',
  silence_percent_of_call: 'percentSilenceEvents',

  talkover_max_duration: 'maxTalkoverDuration',
  talkover_min_duration: 'minTalkoverDuration',
  talkover_average_duration: 'averageTalkoverDuration',
  talkover_total_duration: 'totalTalkoverDuration',
  talkover_total_events: 'talkoverEvents',
  talkover_percent_of_call: 'percentTalkoverEvents',

  pause_max_duration: 'maxPauseDuration',
  pause_min_duration: 'minPauseDuration',
  pause_average_duration: 'averagePauseDuration',
  pause_total_duration: 'totalPauseDuration',
  pause_total_events: 'pauseEvents',
  pause_percent_of_call: 'percentPause',

  hold_max_duration: 'maxHoldDuration',
  hold_min_duration: 'minHoldDuration',
  hold_average_duration: 'averageHoldDuration',
  hold_total_duration: 'totalHoldDuration',
  hold_total_events: 'holdEvents',
  hold_percent_of_call: 'percentHold',

  caa_fields: 'analytics',
  metadata_fields: 'customMetaData',
  number: 'number',
  expDate: 'expirationDate',
  assocCallId: 'associatedContactId',
  avayaDecimalUCID: 'avayaDecimalUCID',

  recordingdevice_fields: 'recording',
  phone_extension: 'telephoneNumber',
  pc_hostname: 'recordingDevice',
  pc_ip_address: 'recordingIP',

  status_fields: 'userRecordingStatus',
  registration_state: 'phoneRegistration',
  qm_login_status: 'pcLogin',
  acd_login_status: 'acdLogin',
  recording_last_successful: 'lastSuccess',
  recording_last_failed: 'recordingLastError',
  recording_last_voice_status: 'voice',
  recording_last_screen_status: 'screen',
  recording_last_failed_cause: 'recordingLastErrorCause',
  failure_cause: 'errorCause',
  screen_recording_ip: 'screenAddress',
  voice_recording_ip: 'voiceAddress',
  hasVoice: 'hasVoice',
  hasScreen: 'hasScreen',
  assocCallIdCount: 'assocCallIdCount',
  isInbound: 'isInbound',
  analytics_fields: 'analytics_fields',
  isTranscribed: 'isTranscribed',
  hasText: 'hasText',

  goal_fields: 'adHocFieldLabel',
  goalId: 'goalIdLabelv2',
  goalDue: 'dueDateLabel',
  goalName: 'goalName',
  goalInstruction: 'instructionsLabel',
  goalActionName: 'actionLabel',
  end_of_call_workflow_rule: 'endOfCallWorkflow',
  daily_workflow_rule: 'dailyWorkflow',
  eval_score_prediction: 'PredictiveEvaluationScore',
  net_promoter_score: 'netPromoterScore',
  net_promoter_score_prediction: 'PredictiveNetPromoterScore',
  sentiment: 'sentiment',
  external_party: 'externalParty',
  text_preview: 'textPreview',
  interaction_preview: 'interactionPreview',
  channel: 'channel',
} as const
